import Model from "./Model";

export default class extends Model {
    async loadTable(
      page,
      limit,
      search = '',
      brand = null,
      status = null
    ) {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                search,
                brand,
                status
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        
        if(response)
        {
            let result = {
                tbody: [],
                pages: response.pages,
            };

            response.items.forEach(address => {
                let telem = {
                    tbody: {}
                };
                telem.id = address.id;
                telem.tbody.status = address.status;
                telem.tbody.comment = address.comment;
                telem.tbody.status_title = address.status_title;
                telem.tbody.street = address.street;
                telem.tbody.city_name = address.city_name;
                telem.tbody.region_name = address.region_name;
                telem.tbody.number = address.number;
                telem.tbody.client_name = address.client_name;
                telem.tbody.brand_name = address.brand_name;
                telem.tbody.worktime = address.worktime;
                telem.tbody.devices = address.devices;
                telem.tbody.devicesActive = address.devicesActive;
                result.tbody.push(telem);
            });

            return result
        }
        return {
            tbody: [],
            pages: 0,
        };
    }
}
